import React, { Component } from 'react';
import { Footer } from "./components";
import  { ContactUs } from "./containers"
import { BrowserRouter as Router } from "react-router-dom";
import Routes from './routes'
import NavBar from "./components/Link/NavBar";

export default class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <NavBar/>
          <Routes/>
          <ContactUs/>
          <Footer/>
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js